/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import * as stringParser from '../../../util/string.util'
import Currency from '../currency'


// let connection = null
let blinkTime = null
export default class FancyMarket extends Component {
    _ismounted = false
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            book: {},
            market: {},
            infoHide: true,
            width: document.documentElement.clientWidth,
            lastBook: {},
            mktMsg:''
        };
    }
    componentDidMount() {
        let self = this;

        this._ismounted = true

        const socket = this.props.socket;
        if (this._ismounted) {
            this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
                if (this.props.selected_market === this.props.market.marketId && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                    this.props.betForm("", "")
                }
            })
        }
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        socket.emit('market_room', this.props.market.marketId)
        // if(this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1){
        //     this.props.updateSubscribedMarkets(this.props.market.marketId)
        // }
        let stream = ""
        socket.on("message_room", data => {
            let objData = JSON.parse(data)
            if(!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId ===  this.props.market.marketId){
               this.setState({mktMsg:objData.payload.message})
            } 
        });
        socket.on("market_room", data => {
            // let objData = JSON.parse(data)
            // if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
            //     this.setState({ mktMsg: objData.payload.message })
            // } else 
            if (stream !== data && this._ismounted) {
                stream = data
                let newBook = null
                // if (this.props.consoleRights) {
                //     console.log('fancy market - ' + this.props.market.marketId)
                //     console.log(new Date().toLocaleString() + ' _ ' + new Date().getMilliseconds());
                //     console.log(data)
                //     console.log('------------------------------------')
                // }
                try {
                    newBook = stringParser.deSrlz(data)
                } catch {
                    let baseData = {
                        marketId: this.props.market.marketId,
                        status: "OPEN",
                        runners: []
                    }
                    Array.prototype.forEach.call(this.state.market.runners, (rnr) => {
                        let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                        baseData.runners.push(data)
                    })
                    newBook = baseData
                }
                if (this.props.market.marketId === newBook.marketId && this._ismounted) {
                    this.props.updateBook(this.props.market.marketId, newBook)
                    let curBook = this.state.book
                    if (!curBook || !curBook.runners) {
                        this.setState({ book: newBook })
                        return false
                    }
                    Array.prototype.forEach.call(curBook.runners, (rn, i) => {
                        let nrn = newBook.runners[i]
                        if (!nrn) {
                            nrn = {}
                            nrn.back = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                            nrn.lay = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                        }
                        if (!nrn.back || nrn.back.length === 0) {
                            newBook.back = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                        }
                        Array.prototype.forEach.call(rn.back, (bk, j) => {
                            if (!!nrn.back[j]) {
                                if (bk.price !== nrn.back[j].price) {
                                    nrn.back[j].has_blink = true
                                }
                                else {
                                    nrn.back[j].has_blink = false
                                }
                            }
                        })
                        if (!nrn.lay || nrn.lay.length === 0) {
                            newBook.back = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                        }
                        if (!!rn.lay && rn.lay.length > 0) {
                            Array.prototype.forEach.call(rn.lay, (ly, k) => {
                                if (!!nrn.lay[k]) {
                                    if (ly.price !== nrn.lay[k].price) {
                                        nrn.lay[k].has_blink = true
                                    }
                                    else {
                                        nrn.lay[k].has_blink = false
                                    }
                                }
                            })
                        }
                        newBook.runners[i] = nrn
                    });
                    if (!!this.props.isVisible) {
                        this.setState({ book: newBook }, () => {
                            if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                this.props.betForm("", "")
                            }
                            let self = this
                            blinkTime = setTimeout(function blink() {
                                Array.prototype.forEach.call(curBook.runners, (rn, i) => {
                                    let nrn = newBook.runners[i]
                                    Array.prototype.forEach.call(rn.back, (bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    Array.prototype.forEach.call(rn.lay, (ly, k) => {
                                        if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                self.setState({ book: newBook })
                            }, 500)
                        })
                    }
                    else {
                        this.setState({ lastBook: newBook })
                    }
                }
            }
        });
        socket.on('disconnect', () => {
            socket.emit('market_room', this.props.market.marketId)
        })
        this._ismounted = true
    }
    componentWillUnmount() {
        this._ismounted = false
        clearTimeout(blinkTime)
        // const socket = this.props.socket;
        // connection.off()
    }
    componentWillReceiveProps() {
        if (this.props.isEventUpdate) {
            this.setState({ market: this.props.market, book: {} }, () => {
                this._ismounted = true

                const socket = this.props.socket;
                if (this._ismounted) {
                    this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : !!this.props.market.metadata && !!this.props.market.metadata.book ? this.props.market.metadata.book : {} }, () => {
                        if (this.props.selected_market === this.props.market.marketId && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                            this.props.betForm("", "")
                        }
                    })
                }
                if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
                    return false
                }
                socket.emit('market_room', this.props.market.marketId)
                // if(this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1){
                //     this.props.updateSubscribedMarkets(this.props.market.marketId)
                // }
                let stream = ""
                socket.on("message_room", data => {
                    let objData = JSON.parse(data)
                    if(!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId ===  this.props.market.marketId){
                       this.setState({mktMsg:objData.payload.message})
                    } 
                });
                socket.on("market_room", data => {
                    // let objData = JSON.parse(data)
                    // if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
                    //     this.setState({ mktMsg: objData.payload.message })
                    // } else 
                    if (stream !== data && this._ismounted) {
                        stream = data
                        let newBook = null
                        try {
                            newBook = stringParser.deSrlz(data)
                        } catch {
                            let baseData = {
                                marketId: this.props.market.marketId,
                                status: "OPEN",
                                runners: []
                            }
                            Array.prototype.forEach.call(this.state.market.runners, (rnr) => {
                                let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                                baseData.runners.push(data)
                            })
                            newBook = baseData
                        }
                        if (this.props.market.marketId === newBook.marketId && this._ismounted) {
                            this.props.updateBook(this.props.market.marketId, newBook)
                            let curBook = this.state.book
                            if (!curBook || !curBook.runners) {
                                this.setState({ book: newBook })
                                return false
                            }
                            Array.prototype.forEach.call(curBook.runners, (rn, i) => {
                                let nrn = newBook.runners[i]
                                if (!nrn) {
                                    nrn = {}
                                    nrn.back = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                                    nrn.lay = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                                }
                                if (!nrn.back || nrn.back.length === 0) {
                                    newBook.back = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                                }
                                Array.prototype.forEach.call(rn.back, (bk, j) => {
                                    if (!!nrn.back[j]) {
                                        if (bk.price !== nrn.back[j].price) {
                                            nrn.back[j].has_blink = true
                                        }
                                        else {
                                            nrn.back[j].has_blink = false
                                        }
                                    }
                                })
                                if (!nrn.lay || nrn.lay.length === 0) {
                                    newBook.back = [{ price: "", size: "" }, { price: "", size: "" }, { price: "", size: "" }]
                                }
                                if (!!rn.lay && rn.lay.length > 0) {
                                    Array.prototype.forEach.call(rn.lay, (ly, k) => {
                                        if (!!nrn.lay[k]) {
                                            if (ly.price !== nrn.lay[k].price) {
                                                nrn.lay[k].has_blink = true
                                            }
                                            else {
                                                nrn.lay[k].has_blink = false
                                            }
                                        }
                                    })
                                }
                                newBook.runners[i] = nrn
                            });
                            this.setState({ book: newBook }, () => {
                                if (this.props.selected_market === this.props.market.marketId && this.props.market.bettingType === "BOOKMAKER" && (this.state.book.sportingEvent || this.state.book.status !== "OPEN")) {
                                    this.props.betForm("", "")
                                }
                                let self = this
                                blinkTime = setTimeout(function blink() {
                                    Array.prototype.forEach.call(curBook.runners, (rn, i) => {
                                        let nrn = newBook.runners[i]
                                        Array.prototype.forEach.call(rn.back, (bk, j) => {
                                            if (!!nrn.back[j]) {
                                                nrn.back[j].has_blink = false
                                            }
                                        })
                                        Array.prototype.forEach.call(rn.lay, (ly, k) => {
                                            if (!!nrn.lay[k]) { nrn.lay[k].has_blink = false }
                                        })
                                        newBook.runners[i] = nrn
                                    });
                                    self.setState({ book: newBook })
                                }, 500)
                            })
                        }
                    }
                });
                socket.on('disconnect', () => {
                    socket.emit('market_room', this.props.market.marketId)
                })
                this._ismounted = true
            })
        }
    }
    render() {
        let market = this.props.market;
        let book = this.state.book;
        let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners[0] : null
        let mktLineExpo = {}
        let mktAgentLineExpo = {}
        let isExpo = false
        let isAgentExpo = false
        market.expo = !!this.props.mktExpos[market.marketId] ? this.props.mktExpos[market.marketId] : {}
        market.agentExpo = !!this.props.mktAgentExpos[market.marketId] ? this.props.mktAgentExpos[market.marketId] : {}

        let marketExpo = 0
        let marketAgentExpo = 0
        let expoArr = {}//[]
        let expoAgentArr = {}//[]

        !!market.expo.runnersExposure && Array.prototype.forEach.call(Object.keys(market.expo.runnersExposure), (i) => {
            // if(!!market.expo.runnersExposure[i]>-1 && !!market.expo.runnersExposure[i].sharingMe>-1){
            // expoArr.push((market.expo.runnersExposure[i].sharingMe))
            expoArr[market.expo.runnersExposure[i].runnerId] = market.expo.runnersExposure[i].sharingMe
            mktLineExpo[i] = {}
            mktLineExpo[i].expo = ((market.expo.runnersExposure[i].sharingMe))
            // }
        })

        !!market.agentExpo.runnersExposure && Array.prototype.forEach.call(Object.keys(market.agentExpo.runnersExposure), (i) => {
            // if(!!market.expo.runnersExposure[i]>-1 && !!market.expo.runnersExposure[i].sharingMe>-1){
            // expoAgentArr.push((market.agentExpo.runnersExposure[i].sharingUp))
            expoAgentArr[market.agentExpo.runnersExposure[i].runnerId] = market.agentExpo.runnersExposure[i].sharingUp
            mktAgentLineExpo[i] = {}
            mktAgentLineExpo[i].expo = ((market.agentExpo.runnersExposure[i].sharingUp))
            // }
        })
        const expoArrKeys = Object.keys(expoArr);
        isExpo = expoArrKeys.length > 0

        const expoAgentArrKeys = Object.keys(expoAgentArr);
        isAgentExpo = expoAgentArrKeys.length > 0

        let minRunnerId = "";
        let maxRunnerId = "";
        if(isExpo){
            minRunnerId = Math.min(...expoArrKeys);
            maxRunnerId = Math.max(...expoArrKeys);
        }

        if(isAgentExpo){
            minRunnerId = minRunnerId === "" ? Math.min(...expoAgentArrKeys) : (Math.min(...expoAgentArrKeys) < minRunnerId ? Math.min(...expoAgentArrKeys) : minRunnerId);
            maxRunnerId = maxRunnerId === "" ? Math.max(...expoAgentArrKeys) : (Math.max(...expoAgentArrKeys) > maxRunnerId ? Math.max(...expoAgentArrKeys) : maxRunnerId);
        }
        let marketExpObj = {};
        if(minRunnerId !== '' && maxRunnerId !== ''){
            for(let indx = minRunnerId; indx<=maxRunnerId ; indx++){
                let totExpo1 = 0
                if(!!expoArr[indx])
                {
                    totExpo1 = totExpo1 + expoArr[indx];
                }
                if(!!expoAgentArr[indx])
                {
                    totExpo1 = totExpo1 + expoAgentArr[indx];
                }
                // if(totExpo1 !== 0){
                    marketExpObj[indx] = totExpo1;
                // } 
            }
        }

        // for (let ky of Object.keys(marketExpObj)){
        //     mktLineExpo[ky] = {}
        //     mktLineExpo[ky].expo = marketExpObj[ky]
        // }

        // if(isExpo && isAgentExpo){
            
        // } else if(isExpo){
        //     marketExpo = Math.min(...Object.values(expoArr));//expoArr.length > 0 ? Math.min(...expoArr) : 0
        // } else if(isAgentExpo){
        //     marketExpo = Math.min(...Object.values(expoAgentArr));
        // }
        marketExpo = isExpo || isAgentExpo ? Math.min(...Object.values(marketExpObj)) : 0
        // marketAgentExpo = expoAgentArr.length > 0 ? Math.min(...expoAgentArr) : 0
        let runnerCount = 0
        if (!!book.runners && book.runners.length > 1) {
            let runnerList = book.runners.filter((rnr) => {
                return rnr.status !== "REMOVED" && rnr.status !== "SUSPENDED"
            })
            runnerCount = runnerList.length
        }
        if (!!book.runners && book.runners.length > 0) {
            book.runners = book.runners.sort(function (a, b) {
                return a.selectionId - b.selectionId;
            })
        }
        let multiplayFector = market.marketCondition.volume;
        let currencyConversion = JSON.parse(localStorage.getItem('userAccData')).currencyConversion;
        return (
            <>
                {!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk &&
                    <>
                        <tr className="brblumobile d-none">
                            <td colSpan="3">
                                {/* <div className="w-100">
                                    <span className="in-play-title-m" onClick={() => { if (isExpo) { this.props.showExpo(mktLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null) } }}>{market.marketName} </span>
                                    <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                </div>
                                {!this.state.infoHide && <div className="mobile-show d-none" style={{ background: "#ccdddd", padding: "5px", borderRadius: "5px", position: "absolute", width: "94%", zIndex: "1" }}>
                                    <span className="d-block "> Max:<span>{market.maxBet}</span> |  Max Profit:<span>{market.marketCondition.maxProfit}</span><span onClick={() => { this.setState({ infoHide: true }) }} style={{ marginRight: 5, cursor: "pointer" }} className="float-right">X</span></span>
                                </div>} */}
                                <div className="w-100">
                                    {/* <a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }} className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "add-pin-d select-pin-d mr-1" : "add-pin-d mr-1"} style={{ "cursor": "pointer" }} title="Add to Multi Markets"></a> */}
                                    <span className="in-play-title-m" onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }}>{market.marketName} [{this.props.orderCount}] </span>
                                    <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className={runnerCount > 1 ? "fancyw-50 v-align px-1" : "fancyw-50 px-1"}>
                                <div className="runningf in-play-title ">
                                    <div className='d-block'>
                                        {this.state.width > 991 ?
                                            <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                            : this.state.width >= 768 && market.marketName.length < 52 ?
                                                <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                : this.state.width >= 575 && market.marketName.length < 45 ?
                                                    <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                    : this.state.width >= 500 && market.marketName.length < 37 ?
                                                        <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                        : this.state.width >= 469 && market.marketName.length < 37 ?
                                                            <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                            : this.state.width >= 414 && market.marketName.length < 37 ?
                                                                <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                                : this.state.width >= 390 && market.marketName.length < 35 ?
                                                                    <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                                    : this.state.width >= 375 && market.marketName.length < 35 ?
                                                                        <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                                        : this.state.width >= 374 && market.marketName.length < 35 ?
                                                                            <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                                            : this.state.width >= 320 && market.marketName.length < 25 ?
                                                                                <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                                                :
                                                                                // eslint-disable-next-line jsx-a11y/no-distracting-elements
                                                                                <marquee scrollamount="2" behavior="scroll">
                                                                                    <span className="marketnamemobile" title={market.marketName} onClick={() => { if (isExpo || isAgentExpo) { this.props.showExpo(this.props.market.marketId, mktLineExpo, mktAgentLineExpo, !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].line) !== 0 ? runner_bk.lay[0].line : null, market.marketName) } }} style={{ cursor: "pointer" }}>{market.marketName} <span className='count-budge'>{this.props.orderCount}</span></span>
                                                                                </marquee>}
                                    </div>
                                    <div>
                                        {(isExpo || isAgentExpo) && <Currency className={"match-odds font-weight-bold d-inline-block"} amount={marketExpo} isOnlyNumber={true} showColor={true} />}
                                        <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                        {!!this.props.msgMarket && this.state.mktMsg === '' && <span className="wid250fancy fancymassagedesktop"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>{this.props.msgMarket}</span></span>}
                                        {this.state.mktMsg !== '' && <span className="wid250fancy fancymassagedesktop"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>{this.state.mktMsg}</span></span>}
                                    </div>
                                    {!this.state.infoHide && <div className="fmass mobile-show fancymassnew" >
                                        <span className="d-block "> Max:<span>{(market.marketCondition.maxBet / currencyConversion).toFixed(2)}</span> |  Max Profit:<span>{(market.marketCondition.maxProfit / currencyConversion).toFixed(2)}</span><span onClick={() => { this.setState({ infoHide: true }) }} style={{ marginRight: 5, cursor: "pointer" }} className="float-right ml-5">X</span></span>
                                    </div>}
                                </div>
                            </td>
                            <td className="w-16">
                                {!!book.runners && book.runners.length > 0 && book.runners.map((runner_bk, i) => {
                                    let is_active = !!book && book !== {} && book.status === "OPEN"
                                    {/* let runnerAllow = this.state.market.provider === "BETHUBS" && i > 0 ? false : true */}
                                    let runnerAllow = this.state.market.provider === "BETHUBS" && runner_bk.status === "SUSPENDED" && i > 0 && (runner_bk.lay.length  === 0 && runner_bk.back.length  === 0 ) ? false : true
                                    if( i>0 && runner_bk.lay.length  > 0 && runner_bk.back.length  > 0){
                                        if(!runner_bk.lay[0].line || !runner_bk.back[0].line ||(runner_bk.lay[0].line === 0  && runner_bk.back[0].line === 0)){
                                            runnerAllow = false
                                        }
                                    }
                                    return <>
                                        {runnerAllow && runner_bk.status !== "REMOVED" &&
                                            <div className={!!book && book !== {} && book.status !== "OPEN" ? "suspended-fancy" : !!book.sportingEvent && !!book.sportingEvent === true ? "ballrunning-fancy" : ""} >
                                                {!!runner_bk.lay && <div className={this.props.type === "line" ? "ask d-inline line-m1" : "ask d-inline"} style={!!runner_bk.lay[0] && runner_bk.lay[0].has_blink ? { background: "gold" } : null} >
                                                    <span className="ask-price" onClick={()=> this.props.openAgentCuttingModal(this.state.market)}>{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && is_active ? runner_bk.lay[0].line : ""}</span>
                                                    {market.provider === "BETFAIR" && market.bettingType === "LINE" ? <span className="ask-price-small">{!!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 ? ((runner_bk.lay[0].size / currencyConversion) * multiplayFector) > 999 ? parseFloat(((runner_bk.lay[0].size / currencyConversion) * multiplayFector) / 1000).toFixed(1) + "K" : ((runner_bk.lay[0].size / currencyConversion) * multiplayFector).toFixed(2) : ""}</span>
                                                        : <span className="ask-price-small">{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.lay[0] && parseFloat(runner_bk.lay[0].price) !== 0 && is_active ? runner_bk.lay[0].price : "0.00"}</span>
                                                    }
                                                </div>}
                                                {!!runner_bk.back && <div className={this.props.type === "line" ? "bid d-inline line-m1" : "bid d-inline"} style={!!runner_bk.back[0] && runner_bk.back[0].has_blink ? { background: "gold" } : null}>
                                                    <span className="bid-price" onClick={()=> this.props.openAgentCuttingModal(this.state.market)}>{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? runner_bk.back[0].line : ""}</span>
                                                    {market.provider === "BETFAIR" && market.bettingType === "LINE" ? <span className="bid-price-small">{!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 ? ((runner_bk.back[0].size / currencyConversion) * multiplayFector) > 999 ? parseFloat(((runner_bk.back[0].size / currencyConversion) * multiplayFector) / 1000).toFixed(1) + "K" : ((runner_bk.back[0].size / currencyConversion) * multiplayFector).toFixed(2) : ""}</span>
                                                        : <span className="bid-price-small">{!!book && book !== {} && book.status !== "CLOSED" && book.status !== "INACTIVE" && !!runner_bk && !!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? runner_bk.back[0].price : "0.00"}</span>
                                                    }
                                                </div>}
                                            </div>}
                                    </>
                                })}</td>
                            <td className="w-16 w-16-1 mobile-hide">
                                <div className={runnerCount > 1 ? "min-max-price min-max-price-center" : "min-max-price"}>
                                    <span className="d-block">Max:<span>{(market.marketCondition.maxBet / currencyConversion).toFixed(2) >= 1000 ? parseInt((market.marketCondition.maxBet / currencyConversion).toFixed(2) / 1000) + "K" : (market.marketCondition.maxBet / currencyConversion).toFixed(2)}</span></span>
                                    <span className="d-block ">MKT:<span>{(market.marketCondition.maxProfit / currencyConversion).toFixed(2) >= 1000 ? parseInt((market.marketCondition.maxProfit / currencyConversion).toFixed(2) / 1000) + "K" : (market.marketCondition.maxProfit / currencyConversion).toFixed(2)}</span></span>
                                </div>
                            </td>
                        </tr>
                        {!!this.props.msgMarket && this.state.mktMsg === '' && <tr className="fancymassagemobile">
                            <td colSpan="3">
                                <div className="w-100"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>{this.props.msgMarket}</span></div>
                            </td>
                        </tr>}
                        {this.state.mktMsg !== '' && <tr className="fancymassagemobile">
                            <td colSpan="3">
                                <div className="w-100"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>{this.state.mktMsg}</span></div>
                            </td>
                        </tr>}
                    </>}
            </>
        )
    }
}
